const Custom_Wall_Lettering = (function() {
  function Custom_Wall_Lettering(){
    this.selectors = {
        bgElement:".customise-wrapper",
        textareaElement: '.user-input-text',
        textColorElement: '[data-text-color]',
        bgColorElement: '[data-bg-color]',
        fontTypeElement: '[data-font-type]',
        outputElemet: '.text-element',
        //outputElemet2: '.text-element-2',
        textColorNameElement:'.text-color-name-element',
        textColorNameElementm:'.text-color-name-element-m',
        bgColorNameElement:'.bg-color-name-element',
        bgColorNameElementm:'.bg-color-name-element-m',
        fontNameElement:'.font-name-element',
        fontNameElementm:'.font-name-element-m',
        autoTriggerElements:['[data-text-color]:eq(2)','[data-bg-color]','[data-font-type]'],
        shrinkElement:'input[data-shrink]',
        reverseElement:'input[data-reverse]',
        aligmentElement:'select[data-alginment]',
        linehightElement:'select[data-linehight]',
        maxwideElement:'[data-maxwide]',
        addToCartButton:".add-to-cart",
        updatePreviewButton:".update-btn"
      };
    this.data = {
          colorCode:"",
          colorCodeName:"",
          colorID:"",
          bgColorCode:"",
          bgColorCodeName:"",
          bgColorID:"",
          fontName:"",
          fontID:"",
          text:"",
          lines:"",
          approxTotalHeight:"",
          reverseText:"",
          isShrink:false,
          isReverse:false,
          textAlign:'center',
          lineheight:"2.5",
          mainId: mainProduct.variants[0].id,
          less100Id:unitProduct.variants[0].id,
          less100Qty:0,
          above100Id:unitProduct.variants[1].id,
          above100Qty:0,
          textWide:0,
          totalQty:0
        };

    this.init();
  };
  Custom_Wall_Lettering.prototype.init = function(){
    $(document).on("change",this.selectors.textColorElement,this.updateColor.bind(this));
    $(document).on("change",this.selectors.bgColorElement,this.updateBgColor.bind(this));
    $(document).on("change",this.selectors.fontTypeElement,this.updateFontType.bind(this));
    $(document).on("input",this.selectors.textareaElement,this.handleUserInput.bind(this));
    $(document).on("change",this.selectors.shrinkElement,this.onShrinkText.bind(this));
    $(document).on("change",this.selectors.reverseElement,this.onReverseText.bind(this));
    $(document).on("change",this.selectors.aligmentElement,this.onAlginMentText.bind(this));
    $(document).on("change",this.selectors.linehightElement,this.onLineheightChange.bind(this));
    $(document).on("click",this.selectors.updatePreviewButton,this.updateOutput.bind(this));
    $(document).on("click",this.selectors.addToCartButton,this.addtoCart.bind(this));
    
    this.selectors.autoTriggerElements.forEach(function(element){
      $(element).first().attr('checked','checked').trigger("change");
    });
  };
  Custom_Wall_Lettering.prototype.b64toBlob = function(b64Data, contentType, sliceSize){
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, {type: contentType});
    return blob;
  };
  Custom_Wall_Lettering.prototype.addtoCart = function(event){
    const _this = this;
    console.log(Math.trunc(_this.data.totalQty) , "total number");
    html2canvas(document.querySelector(this.selectors.bgElement)).then(function (canvas) {
      const image = canvas.toDataURL();  
      //const image = canvas.toDataURL('image/png')
      const block = image.split(";");
      // Get the content type of the image
      const contentType = block[0].split(":")[1];// In this case "image/gif"
      // get the real base64 content of the file
      const realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."
      
      // Convert it to a blob to upload
      const blob = _this.b64toBlob(realData, contentType);
      const formData = new FormData();
      const packageId = new Date().getTime();
      const items=[
        {
          id:_this.data.mainId,
          quantity:Math.trunc(_this.data.totalQty),
          properties:{
            _isMaster:true,
            previewImage:blob,
            _packageId:packageId,
            Font:_this.data.fontName,
            //Color_Code:_this.data.colorCode,
            Decal_Color:_this.data.colorCodeName,
           // Background_Color:_this.data.bgColorCodeName,
            //Background_Color_Code:_this.data.bgColorCode,
            Text:_this.data.text,
            Total_Lines:_this.data.lines,
            Approx_Total_Height:_this.data.approxTotalHeight,
            Shrink_Last_Line:(_this.data.isShrink == true ? 'Yes' : 'No'),
            Mirror_Image:(_this.data.isReverse == true ? 'Yes' : 'No'),
            Tallest_Line_Height:_this.data.lineheight,
            Alignment:_this.data.textAlign,
            Longest_Line_Width:_this.data.textWide
          }
        },
        
      ];
     
      console.log(items,'abh');
      for ( var key in items ) {
        formData.append(`items[${key}][id]`, +items[key].id);
        formData.append(`items[${key}][quantity]`, +items[key].quantity);
        for(var property in items[key].properties){
          //console.log(`items[${key}][properties][${property}]`, items[key].properties[property]);
          formData.append(`items[${key}][properties][${property}]`, items[key].properties[property]);
        }
      }
      for (const pair of formData.entries()) {
        //console.log(`${pair[0]}, ${pair[1]}`);
      }
      console.log(formData,'formData')
      fetch(window.Shopify.routes.root + 'cart/add.js?_easygift_form_payload=true', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        var urlParams = new URLSearchParams(window.location.search);
        var fromCart = urlParams.get('edit');       
        if(fromCart == 'true'){
            Cookies.set('deleteKey' , Cookies.get('lineKey'));
            Cookies.remove('lineKey');
        } 
        window.location = "/cart";
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    });
  };
  
  Custom_Wall_Lettering.prototype.onLineheightChange = function(event){
    event.preventDefault();
    this.data.lineheight = event.target.value;
    console.log(event.target.value,this.data.lineheight);
    this.updateOutput();
    document.querySelector('[data-maxwide]').style.color = 'red';
    document.querySelector('[data-symbol]').style.color = 'red';
    document.querySelector('[data-maxwide]').classList.add("blink");
    document.querySelector('[data-symbol]').classList.add("blink");
    setTimeout(function(){
      document.querySelector('[data-maxwide]').style.color = 'black';
      document.querySelector('[data-symbol]').style.color = 'black';
      document.querySelector('[data-maxwide]').classList.remove("blink");
      document.querySelector('[data-symbol]').classList.remove("blink");     
    },2000)    
  };
  Custom_Wall_Lettering.prototype.onShrinkText = function(event){
    event.preventDefault();
     //this.data.isShrink = (event.target.checked == true ? 'Yes' : 'No');
    this.data.isShrink = event.target.checked ; 
     this.updateOutput();
    document.querySelector('[data-maxwide]').style.color = 'red';
    document.querySelector('[data-symbol]').style.color = 'red';
    document.querySelector('[data-maxwide]').classList.add("blink");
    document.querySelector('[data-symbol]').classList.add("blink");
    setTimeout(function(){
      document.querySelector('[data-maxwide]').style.color = 'black';
      document.querySelector('[data-symbol]').style.color = 'black';
      document.querySelector('[data-maxwide]').classList.remove("blink");
      document.querySelector('[data-symbol]').classList.remove("blink");     
    },2000)    
  };
  Custom_Wall_Lettering.prototype.onReverseText = function(event){
    event.preventDefault();
   // this.data.isReverse = (event.target.checked == true ? 'Yes' : 'No');
    this.data.isReverse = event.target.checked ; 
    this.updateOutput();
  };
  Custom_Wall_Lettering.prototype.onAlginMentText = function(event){
    event.preventDefault();
    this.data.textAlign = event.target.value;
    console.log(event.target.value);
    this.updateOutput();
  };
  Custom_Wall_Lettering.prototype.updateColor = function(event){
    event.preventDefault();
    console.log(this , "hello");
    document.querySelector(this.selectors.textColorNameElement).innerText = event.target.getAttribute('data-title');
    document.querySelector(this.selectors.textColorNameElementm).innerText = event.target.getAttribute('data-title');
    this.data.colorCode = event.target.value;
    this.data.colorCodeName = event.target.getAttribute('data-title');
    this.data.colorID = event.target.getAttribute('data-id');
    this.updateOutput();
  };
  Custom_Wall_Lettering.prototype.updateBgColor = function(event){
    event.preventDefault();
    document.querySelector(this.selectors.bgColorNameElement).innerText = event.target.getAttribute('data-title');
    document.querySelector(this.selectors.bgColorNameElementm).innerText = event.target.getAttribute('data-title');
    this.data.bgColorCode = event.target.value;
    this.data.bgColorCodeName = event.target.getAttribute('data-title');
    this.data.bgColorID = event.target.getAttribute('data-id');
    this.updateOutput();
  };
  Custom_Wall_Lettering.prototype.updateFontType = function(event){
    event.preventDefault();
    document.querySelector(this.selectors.fontNameElement).innerText = event.target.getAttribute('data-title');
    document.querySelector(this.selectors.fontNameElementm).innerText = event.target.getAttribute('data-title');
    this.data.fontName = event.target.value;
    this.data.fontID = event.target.getAttribute('data-id');
    this.updateOutput();
  };
  Custom_Wall_Lettering.prototype.handleUserInput = function(event){
    event.preventDefault();
    this.data.text = event.target.value;
    this.data.lines = event.target.value.split(/\r\n|\r|\n/).length;
    this.updateOutput();
    document.querySelector('[data-maxwide]').style.color = 'red';
    document.querySelector('[data-symbol]').style.color = 'red';
    document.querySelector('[data-maxwide]').classList.add("blink");
    document.querySelector('[data-symbol]').classList.add("blink");
    setTimeout(function(){
      document.querySelector('[data-maxwide]').style.color = 'black';
      document.querySelector('[data-symbol]').style.color = 'black';
      document.querySelector('[data-maxwide]').classList.remove("blink");
      document.querySelector('[data-symbol]').classList.remove("blink");     
    },2000)
  };

  Custom_Wall_Lettering.prototype.reverseText = function(){
    const textParts = this.data.text.split("\n");
    let reverseTextString = "";
    for(const userText of textParts){
      if(userText.trim().length > 0){
        reverseTextString +=  userText.split("").reverse().join("")+"\n";
      }
    }
    this.data.reverseText = reverseTextString;
  };

  Custom_Wall_Lettering.prototype.measureText = function(text,fontType){
    const canvas = document.createElement("canvas");
    //canvas.style.letterSpacing = '10px';
    const ctx = canvas.getContext("2d");
    ctx.font =fontType;
    return ctx.measureText(text.trimEnd());
  };
  Custom_Wall_Lettering.prototype.calculateHeightWidth = async function(splitUserText){
    let widths = [];
    let heights = [];
    let fontSize = 144;
    
      for(let i in splitUserText){
        if(splitUserText[i].trim().length > 0){
          if(splitUserText.length > 1 && i == (splitUserText.length-1) && this.data.isShrink){
            fontSize = fontSize/1.6;
          }
          const textMetrics = await this.measureText(splitUserText[i],`${fontSize}pt ${this.data.fontName}`);
          const fontHeight = textMetrics.fontBoundingBoxAscent + textMetrics.fontBoundingBoxDescent;
          const actualHeight = textMetrics.actualBoundingBoxAscent + textMetrics.actualBoundingBoxDescent;
          widths.push(textMetrics.width);
          heights.push(actualHeight);
        }
      }
      return [widths,heights];
  };
  Custom_Wall_Lettering.prototype.updateOutput = async function(){
    const that = this;
    let splitUserText = "";

    console.log(this,'this is here')
   
    splitUserText = this.data.text.split("\n");
    console.log(splitUserText,163);

    let line_height = document.querySelector(".line_height");
    let total_lines = document.querySelector(".total_lines");
    let decal_width = document.querySelector(".decal_width");
    let min_height = document.querySelector(".min_height");
    let max_height = document.querySelector(".max_height");

    line_height.innerHTML = document.querySelector("[data-linehight]").value;
    if(document.querySelector(".user-input-text").value == ""){
       total_lines.innerHTML = 0;
    }else{
       total_lines.innerHTML = document.querySelector(".user-input-text").value.split(/\r\n|\r|\n/).length;
    }
    let thiss = this;
    setTimeout(function(){
      let min_height_value = (Number(line_height.innerHTML) * Number(total_lines.innerHTML)) + ((Number(total_lines.innerHTML) - 1) * (Number(line_height.innerHTML) * 0.175));
      let max_height_value = (Number(line_height.innerHTML) * Number(total_lines.innerHTML)) + ((Number(total_lines.innerHTML) - 1) * (Number(line_height.innerHTML) * 0.60));
      decal_width.innerHTML =  document.querySelector("[data-maxwide]").innerHTML;
      console.log(min_height_value , max_height_value);
      min_height.innerHTML = min_height_value.toFixed(2);
      max_height.innerHTML = max_height_value.toFixed(2);
      thiss.data.approxTotalHeight = `${min_height_value.toFixed(2)} - ${max_height_value.toFixed(2)}`;
    },200);
    
    let userTextHtml = "";
    for(let userText of splitUserText){
      if(userText.trim().length > 0){
        userTextHtml+=`<div>${userText.replace(/ /g,'&nbsp;')}</div>`;
      }
    }
    let isApplied = false;
    if(userTextHtml.trim().length > 0){
      document.querySelector(this.selectors.outputElemet).innerHTML = userTextHtml;
      //document.querySelector(this.selectors.outputElemet2).innerHTML = userTextHtml;
      isApplied = true;
    }else{
      document.querySelector(this.selectors.outputElemet).innerHTML = "";
      isApplied = false;
    }
    if(this.data.isReverse){
      document.querySelector(this.selectors.outputElemet).classList.add("mirror");
    }else{
      document.querySelector(this.selectors.outputElemet).classList.remove("mirror");
    }
    document.querySelector(this.selectors.outputElemet).style.fontFamily=this.data.fontName;
    document.querySelector(this.selectors.outputElemet).style.color=this.data.colorCode;
    document.querySelector(this.selectors.bgElement).style.backgroundColor = this.data.bgColorCode;
    
    document.querySelector(this.selectors.bgElement).classList.remove('text-center');
    document.querySelector(this.selectors.bgElement).classList.remove('text-left');
    document.querySelector(this.selectors.bgElement).classList.remove('text-right');
    document.querySelector(this.selectors.bgElement).classList.add(`text-${this.data.textAlign}`);
    /*document.querySelectorAll(`${this.selectors.outputElemet} div`).forEach(function(element,index){
        element.style.lineHeight = that.data.lineheight;
    });*/
    
    //document.querySelector(this.selectors.outputElemet2).style.fontFamily=this.data.fontName;
    if(this.data.isShrink && splitUserText.length > 1){
      document.querySelector(this.selectors.outputElemet).classList.add("last-shrink");
      //document.querySelector(this.selectors.outputElemet2).classList.add("last-shrink");
    }else{
      document.querySelector(this.selectors.outputElemet).classList.remove("last-shrink");
      //document.querySelector(this.selectors.outputElemet2).classList.remove("last-shrink");
    }
    
    const widthsheights  = await this.calculateHeightWidth(splitUserText);
    const widths = widthsheights[0];
    const heights = widthsheights[1];
    const maxWidth = Math.max(...widths);
    const ppi = heights;
    const maxPpi = (Math.max(...ppi)/this.data.lineheight);
    const maxinswide = Math.round((maxWidth/maxPpi));
    this.data.textWide = maxinswide;
    document.querySelector(this.selectors.maxwideElement).innerText = (maxinswide > 0 ? maxinswide : 0);
    
    let sqin=0;
    for(const i in widths){
      sqin+=(maxWidth/maxPpi)*(heights[i]/maxPpi);
    }
    sqin = Math.ceil(sqin);
    let price = 10;
    const first100Price = 0.19;
    const after100Price = 0.08; 
    
    if (sqin <= 100){
      this.data.less100Qty = sqin;
      price += sqin*first100Price;
    }else{
      this.data.less100Qty = 100;
      this.data.above100Qty = (sqin-100);
      price +=(100*first100Price)+((sqin-100)*after100Price);
    }
   

    
    price = price * 100;
    this.data.totalQty = price;
    console.log(this.data.totalQty);
    let price2 = price;
    console.log(this.data.totalQty, 'this.data.totalQty',price)
    document.querySelector('.custom-price').innerHTML = theme.Currency.formatMoney(price2 * Shopify.currency.rate);
    if(sqin > 0){
      document.querySelector(this.selectors.addToCartButton).removeAttribute("disabled");
    }else{
      document.querySelector(this.selectors.addToCartButton).setAttribute("disabled","disabled");
    }
    };
  return Custom_Wall_Lettering;
})();
let CustomObject = {};
jQuery(document).ready(function($){
 CustomObject =  new Custom_Wall_Lettering(); 
      $("span.info-link").on("click",function(){
      $.fancybox.open({
        src:$(this).attr('data-link')
      });
  }); 
  $('.customise-wrapper').hover(
    function() {
        $(this).addClass('j-left');
        $(this).children('.text-element').animate({ 'zoom': 2 }, 200);
    },
    function() {
        $(this).removeClass('j-left');
        $(this).children('.text-element').animate({ 'zoom': 1 }, 200);
    });  

  $(document).on("click",".custom-title-click",function(){
    const elementId = $(this).next('.custom-hide').attr('id');
    $(".custom-title-click").addClass('collesped');
    $('.custom-hide').not(`#${elementId}`).hide("slow");
    $(this).next('.custom-hide').slideToggle("slow");
    $(this).toggleClass('collesped');
  });
  $(document).on("click",".generate-url-btn",function(){
    const button = $(this);
    const baseURL = window.location.origin+window.location.pathname;
    /*let ArgumentsCustom = [];
    ArgumentsCustom['colorCode'] = CustomObject.data.colorCode;
    ArgumentsCustom['bgColorCode'] = CustomObject.data.bgColorCode;
    ArgumentsCustom['fontName'] = CustomObject.data.fontName;
    ArgumentsCustom['text'] = CustomObject.data.text;
    ArgumentsCustom["isShrink"] = CustomObject.data.isShrink;
    ArgumentsCustom["isReverse"] = CustomObject.data.isReverse;
    ArgumentsCustom["textAlign"] = CustomObject.data.textAlign;
    console.log(ArgumentsCustom);*/
    const finalURL = `${baseURL}?colorCode=${CustomObject.data.colorCode.replace("#","")}&bgColorCode=${CustomObject.data.bgColorCode.replace("#","")}&fontName=${CustomObject.data.fontName}&text=${encodeURIComponent(CustomObject.data.text)}&isShrink=${CustomObject.data.isShrink}&isReverse=${CustomObject.data.isReverse}&textAlign=${CustomObject.data.textAlign}&lineheight=${CustomObject.data.lineheight}`;
   //$(".custom-url-section").html(finalURL);
      /*var Url = document.querySelector(".custom_url_textarea");
      Url.value = finalURL;
      console.log(Url.value)
      Url.select();
      document.execCommand("copy");*/
    const encodeURL = encodeURI(finalURL);
    navigator.clipboard.writeText(encodeURL).then(function() {
        button.text(button.data('copytext'));
      setTimeout(function(){
        button.text(button.data('original'));
      },2000);
    }, function() {
        console.log('Copy error')
    });
  });

  $(document).on("click",".download-screenshot-btn",function(){
    const btnEl = $(this);
    btnEl.text(btnEl.attr("loading-text"));
    const selctorElement = document.querySelector(CustomObject.selectors.bgElement);
    html2canvas(selctorElement).then(function (canvas) {
       const image = canvas.toDataURL('image/png',1)
        const a = document.createElement('a')
        a.setAttribute('download', 'my-image.png')
        a.setAttribute('href', image)
        a.click();
      btnEl.text(btnEl.attr("default-text"));
    });
  });
});

$(window).on('load',function(){
  const queryString = decodeURI(window.location.search);
  const urlParams = new URLSearchParams(queryString);
  if(urlParams.get("text")){
    $(".user-input-text").val(urlParams.get("text")).trigger("input");
  }
  if(urlParams.get("colorCode")){
    const colorCode = `#${urlParams.get("colorCode")}`;
    $(`.desktop-options input[data-text-color][value="${colorCode}"]`).prop("checked",true).trigger("change");
  }
  if(urlParams.get("bgColorCode")){
    const bgColorCode = `#${urlParams.get("bgColorCode")}`;
    $(`.desktop-options input[data-bg-color][value="${bgColorCode}"]`).prop("checked",true).trigger("change");
  }
  if(urlParams.get("fontName")){
    const fontName = urlParams.get("fontName");
    $(`.desktop-options input[data-font-type][value="${fontName}"]`).prop("checked",true).trigger("change");
  }
  if(urlParams.get("isShrink")){
    const isShrink = urlParams.get("isShrink");
    if(isShrink == 'true'){
      $('input[data-shrink]').prop("checked",true).trigger("change")  
    }
  }
  if(urlParams.get("isReverse")){
    const isReverse = urlParams.get("isReverse");
    if(isReverse == 'true'){
      $('input[data-reverse]').prop("checked",true).trigger("change")  
    }
  }
  if(urlParams.get("textAlign")){
    const textAlign = urlParams.get("textAlign");
    $('select[data-alginment]').val(textAlign).trigger("change")  
  }
  if(urlParams.get("lineheight")){
    const lineheight = urlParams.get("lineheight");
    $('select[data-linehight]').val(lineheight).trigger("change")  
  }
     if(Cookies.get('isEdit') == 'true'){
       Cookies.remove('isEdit');
       var text = Cookies.get('text');
       var fontColor = Cookies.get('fontColor');
       var font = Cookies.get('font').trim();
       var lineHeight = Cookies.get('lineHeight');
       var shrink = Cookies.get('shrink');
       var reverse = Cookies.get('reverse');
       var aligment = Cookies.get('aligment');  

       $(".user-input-text").val(text.replace(/(<([^>]+)>)/ig,"")).trigger('input');
       $(`input[name="textcolor"][data-title="${fontColor}"]`).prop('checked', true).trigger('change');
       $(`input[name="textfont"][value="${font}"]`).prop('checked', true).trigger('change');
       $(`[data-linehight]`).val(lineHeight).trigger('change');
        
       if(shrink == 'Yes'){
         $('#Shrink').prop('checked',true).trigger('change');
       }
       if(reverse == 'Yes'){
         $('#Reverse').prop('checked',true).trigger('change');
       }      
       $(`[data-alginment]`).val(aligment).trigger('change');
       //$('.text-element').html(`<div>${text}</div>`);
       console.log(text,fontColor,font,lineHeight,shrink,reverse,aligment);
      
       setTimeout(function(){
         Cookies.remove('text');
         Cookies.remove('fontColor');
         Cookies.remove('font');
         Cookies.remove('lineHeight');
         Cookies.remove('shrink');
         Cookies.remove('reverse');
         Cookies.remove('aligment');
       },200);
    } 
   
})
